import { connect, ConnectedProps } from 'react-redux';
import { triggerModal } from 'slices/modal';

import { Footer } from 'components/_V2/Footer/Footer';

const connector = connect(null, {
  triggerModal
});

export type FooterPropsFromRedux = ConnectedProps<typeof connector>;

const FooterContainer = connector(Footer);

export default FooterContainer;
